// extracted by mini-css-extract-plugin
export default {"MobileNav":"MobileNav_MobileNav__0kNWu"};